export class EmpresasModel {
    codEmpresa: string;
    descripcion: string;
    grupoFabril: number;
    constructor() { }
}